import { UserType } from '../constants/userTypes';

const USER_SESSION_KEY = 'UserSession';

const UserInfo = {
  userID: '',
  fullName: '',
  email: '',
  userType: '',
  userProfileImg: '',
  isSubscriber: false,
  products: [],
  subscriptionEndDate: '',
  companyName: '',
  activationPlan: '',
  productCode: '',
};

const UserSessionManager = {
  setSession(userData) {
    if (!userData) return;
    const sessionData = {
      businessAdminId: userData.businessAdminId,
      fullName: userData.fullName,
      email: userData.email,
      userType: userData.userType,
      userProfileImg: userData.userProfileImg,
      isSubscriber: userData.isSubscriber,
      products: userData.products || [],
      subscriptionEndDate: userData.subscriptionEndDate,
      companyName: userData.companyName,
      activationPlan: userData.activationPlan,
      productCode: userData.productCode,
    };    
    localStorage.setItem(USER_SESSION_KEY, JSON.stringify(sessionData));
  },

  getSession() {
    const data = localStorage.getItem(USER_SESSION_KEY);
    console.log('UserSessionManager.getSession()', JSON.parse(data));
    return data ? JSON.parse(data) : null;
  },

  getUserInfo() {
    const data = this.getSession();
    if (!data) return null;
    
    // Create and return a UserInfo object
    return {
      userID: data.userID || '',
      fullName: data.fullName || '',
      email: data.email || '',
      userType: data.userType || '',
      userProfileImg: data.userProfileImg || '',
      isSubscriber: data.isSubscriber || false,
      products: data.products || [],
      subscriptionEndDate: data.subscriptionEndDate || '',
      companyName: data.companyName || '',
      activationPlan: data.activationPlan || '',
      productCode: data.productCode || '',
    };
  },

  isAdmin() {
    const data = this.getSession();
    return data?.userType?.toLowerCase().includes(UserType.ADMIN) ?? false;
  },

  clearSession() {
    localStorage.removeItem(USER_SESSION_KEY);
  },
};

export default UserSessionManager;